/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component, inject} from '@angular/core';
import packageInfo from '../../../../package.json';
import {LogoService} from '../services/logo/logo.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: false,
})
export class FooterComponent {
  year: number = new Date().getFullYear();
  version: string = packageInfo.version;
  private readonly logoService = inject(LogoService);
  protected readonly footerLinks = this.logoService.resolveFooterLinks();
  protected readonly hideFooter = this.logoService.resolveHideFooter();
}

// DEPRECATED: This component is deprecated and will be removed in future releases.
// Please use dynamic-footer.component.ts instead.
